import signature from '../components/signature';
import Keyboard from './Keyboard';
import RenewSignature from './RenewSignature';
import Styles from './Styles';

class DigitalSignature {
  constructor(props) {
    this._styles = new Styles();
    this._keyboard = new Keyboard(this);
    this._renewSignature = new RenewSignature(this, this._keyboard);
    this._authorization = '';
    this.onButtonClick || undefined;
    this.onRenewSignature || undefined;
    this.injectInto = props.injectInto || '#keyboard';

    if (props.autoInit) {
      this.mount();
    }
  }

  mount() {
    // in the future use: /helpers/utils/waitElement
    var interval = setInterval(() => {
      const target = document.querySelector(this.injectInto);
      if (target) {
        clearInterval(interval);

        // init signature
        target.innerHTML = signature();
        this._renewSignature.init();
        this.actions();
      }
    }, 100);
  }

  update() {
    this._keyboard.render(true);
  }

  unmount() {
    document.querySelector(this.injectInto).innerHTML = '';
  }

  setAuthorization(auth) {
    this._authorization = auth;
  }

  actions() {
    document.querySelector('#signature-digital__title').addEventListener('click', () => {
      this._keyboard.render();
    });
  }

  toggleError(message) {
    this._keyboard.toggleError(message);
  }

  get authorization() {
    return this._authorization;
  }

  get tokens() {
    return this._keyboard.tokens;
  }

  subscribe(value) {
    const { onButtonClick } = this;

    if (onButtonClick) {
      onButtonClick(value)
    }
  }
}

export default DigitalSignature;
